import { useState } from "react";
import api from "src/features/auth/axiosConfig";
import { OrderList } from "../../orders/types/orderTypes";
import { notifyError } from "src/assets/toastService";

export interface Pagination {
  page: number;
  pageSize: number;
  totalRecords: number;
  totalPages: number;
}

export const useRunningOrders = () => {
  const [orders, setOrders] = useState<OrderList[]>([]);
  const [pagination, setPagination] = useState<Pagination>({
    page: 1,
    pageSize: 12,
    totalRecords: 0,
    totalPages: 0,
  });
  const [loading, setLoading] = useState(false);

  const fetchOrders = async (
    pageNumber = 1,
    pageSize = 12,
    filters: { search?: string; status?: string; dateFrom?: string; dateTo?: string; sortBy?: string; } = {}) => {
    try {
      setLoading(true);

      const params = new URLSearchParams({
        pageNumber: String(pageNumber),
        pageSize: String(pageSize),
      });

      if (filters.search) params.append("searchBy", filters.search);
      
      // Always filter by pending status
      params.append("OrderStatus", "pending");
      
      if (filters.dateFrom) params.append("dateFrom", filters.dateFrom);
      if (filters.dateTo) params.append("dateTo", filters.dateTo);
      if (filters.sortBy) params.append("sortBy", filters.sortBy);

      const response = await api.get(`/app/v1/pos/order?${params.toString()}`);

      const data = response.data.result || response.data.orders || response.data.data || [];
      const paginationData = response.data.pagination || response.data;

      setOrders(data);
      setPagination({
        page: paginationData.page || pageNumber,
        pageSize: paginationData.pageSize || pageSize,
        totalRecords: paginationData.totalRecords,
        totalPages: paginationData.totalPages || Math.ceil((paginationData.totalRecords || data.length) / pageSize),
      });
    } catch (error) {
      console.error("Error fetching orders:", error);
      notifyError("Failed to fetch orders");
    } finally {
      setLoading(false);
    }
  };

  const handleRefresh = () => fetchOrders(pagination.page);

  return { orders, pagination, loading, setPagination, fetchOrders, handleRefresh, totalRecords: pagination.totalRecords };
};
